<template>
  <div class=" q-mb-md" v-if="items.length > 0"
       :class="{'container': $breakpoints.isGreaterThan('sm')}">
    <h2 class="q-my-md" v-html="$T('home_featured')"
        :class="{'q-px-md': !$breakpoints.isGreaterThan('sm')}"></h2>
    <div class="banners" :class="{'q-pb-md has-border': !$breakpoints.isGreaterThan('sm'),
         'shadow-7': $breakpoints.isGreaterThan('sm')}">
      <div v-if="$breakpoints.isGreaterThan('sm')" class="row">

        <div v-if="first" class="col-8 first" @click="$router.push(first.uri)">
          <v-img :item="first" :img="first.img" :key="first.img.url" :is-video="isVideo">
            <div class="image-caption-category" v-if="first.category">
                <h5 class="q-mt-none q-mb-xs banner-title">{{ $T(first.category) }}</h5>
            </div>
            <div class="image-caption">
              <h5 class="q-mt-none q-mb-xs banner-title" v-html="first.title"></h5>
              <p v-if="published" class="q-ma-none">{{ $T('published at') +': ' + first.subtitle }}</p>
              <p v-if="first.subtitle && !published" class="q-ma-none" v-html="first.subtitle"></p>
            </div>
          </v-img>
        </div>

        <div class="row col-4 content-stretch">
          <div v-for="(item, index) in others" :key="item.img.url" class="col-12" @click="$router.push(item.uri)">
            <v-img :item="item" :img="item.img" :key="item.img.url" :is-video="isVideo">
              <div class="image-caption-category" v-if="item.category">
                  <h5 class="q-mt-none q-mb-xs banner-title">{{ $T(item.category) }}</h5>
              </div>
              <div class="image-caption" v-if="$route.path !== '/world-cup' || index != 0">
                <h5 class="q-mt-none q-mb-xs banner-title" v-html="item.title"></h5>
                <p v-if="subtitleDate && published" class="q-ma-none">{{ $T('published at') +': ' + item.subtitle }}</p>
                <p v-if="item.subtitle && !published" class="q-ma-none" v-html="item.subtitle"></p>
              </div>
            </v-img>
          </div>
        </div>

      </div>

      <div v-else class="horizontal-lock carousel q-mt-md">
        <v-carousel layout="big" :items="items" :is-video="isVideo"/>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: 'VBanners',

  props: {
    items: {
      type: Array,
      required: true
    },
    isVideo: Boolean
  },
  data() {
    return {
      published: false
    }
  },

  computed: {
    first() {
      this.subtitleDate()
      if (this.items && this.items[0] !== undefined)
        return this.items[0]
    },
    others() {
      if (this.items && this.items.length > 1)
        return this.items.slice(1, 3)
      return []
    }
  },
  methods: {
    subtitleDate() {
      for (var item in this.items) {
        if (this.items[item].subtitle && this.$i18n.locale === 'ar') {
          if (this.items[item].subtitle.indexOf('published at') !== -1 ||
              this.items[item].subtitle.indexOf(moment(this.items[item].subtitle).format('DD/MM/YYYY'))){

            this.items[item].subtitle = this.items[item].subtitle.replace('published at: ', '')
            this.items[item].subtitle = moment(this.items[item].subtitle).format('DD/MM/YYYY')
            this.published = true
          } else {
            this.published = false
          }
        }
      }
    }
  },
  mounted() {
    this.subtitleDate()
  }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/front/Banners.vue